import axios from '@/services/axiosInstance'
import {HttpListResponse, Language} from '@/types/commons'

export const httpGetLanguages = (name?: string, page?: string) => {
    const url = '/languages'
    return axios.get<HttpListResponse<Language>>(url, {params: {name, page}}).then(({data}) => data)
}
